import { mapValues } from 'lodash';
import {
  NUMBER_OF_IMAGES_ALLOWED,
  OpenQuestionPinLayoutTemplate,
  OpenQuestionTeacherPin,
  OpenQuestionTeacherPinSettings,
} from '../../models';
import { PinCreationParams } from './pin-helper-types';

export const newOpenQuestionPin = (
  layout: OpenQuestionPinLayoutTemplate
): PinCreationParams<OpenQuestionTeacherPin> => {
  const basePin: PinCreationParams<OpenQuestionTeacherPin> = {
    type: 'OPEN_QUESTION',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      backgroundImage: layout.backgroundImage,
      caseSensitive: false,
      diacriticSensitive: false,
      maximumNumberOfUploadsPerStudent: NUMBER_OF_IMAGES_ALLOWED.zero,
      showStudentNames: true,
      explanation: null,
      questionId: layout.layoutParts.TITLE?.id,
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
    },
    teacherSettings: {
      correctAnswers: [],
    },
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
  };

  if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layout.backgroundTransparency;
  }

  return basePin;
};

/**
 * Returns all correct answers for the open question pin.
 * This includes both predefined correct answers and manually approved answers.
 * Filters out manually rejected answers.
 */
export function openQuestionAllCorrectAnswers(teacherSettings: OpenQuestionTeacherPinSettings): string[] {
  const correctAnswers = teacherSettings.correctAnswers ?? [];
  const manuallyApprovedAnswers = teacherSettings.manuallyApprovedAnswers ?? [];
  const manuallyRejectedAnswers = teacherSettings.manuallyRejectedAnswers ?? [];
  return [...correctAnswers, ...manuallyApprovedAnswers].filter((answer) => !manuallyRejectedAnswers.includes(answer));
}
